import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import css from './PrivateLayout.module.css';
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { SideBar } from "../../components";

const PrivateLayout = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <section className={css.wrap}>
            {isMobile && (
                <MobileHeader 
                    onMenuToggle={toggleMobileMenu}
                    isMenuOpen={isMobileMenuOpen}
                />
            )}
            
            {isMobile && isMobileMenuOpen && (
                <div 
                    className={`${css.overlay} ${isMobileMenuOpen ? css.visible : ''}`}
                    onClick={closeMobileMenu}
                />
            )}

            <aside className={`${css.menuBlock} ${isMobileMenuOpen ? css.open : ''}`}>
                <SideBar onMenuClose={closeMobileMenu} isMobile={isMobile} />
            </aside>

            <section className={css.outletContainer}>
                <Outlet/>
            </section>
        </section>
    );
};

export { PrivateLayout };